export default __webpack_public_path__ + "static/240-efac0bbff64967aeed07bc51814969e0.jpg";